// TREN-317 — persistent banner shown while "View as agent" mode
// is active. Rendered above the dashboard tabs so users always have a
// clear way to exit the scoped view.

import React from 'react'
import { IconUser } from '@tabler/icons-react'

import { Banner } from '@/components/banners/Banner'

export const ViewAsAgentBanner = ({ agent, onClear }) => {
  if (!agent) {
    return null
  }
  // onClose renders Banner's own dismiss button, which exits view-as mode.
  return (
    <Banner brand icon={<IconUser size={16} />} onClose={onClear} className="viewas-banner">
      Viewing as: <strong>{agent.label || agent.full_name}</strong>
    </Banner>
  )
}
